import { render, staticRenderFns } from "./MinhasColecoes.vue?vue&type=template&id=800498ec&scoped=true&"
import script from "./MinhasColecoes.vue?vue&type=script&lang=js&"
export * from "./MinhasColecoes.vue?vue&type=script&lang=js&"
import style0 from "./MinhasColecoes.vue?vue&type=style&index=0&id=800498ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "800498ec",
  null
  
)

export default component.exports